import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { Inputext as InputText, Label } from '@aftersale-next/ui';
export var Input = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$id, _props$id2;

  return /*#__PURE__*/_jsxs(Flex, {
    direction: "column",
    w: "100%",
    children: [/*#__PURE__*/_jsx(Label, {
      htmlFor: (_props$id = props.id) !== null && _props$id !== void 0 ? _props$id : props.name,
      children: props.label
    }), /*#__PURE__*/_jsx(InputText, {
      id: (_props$id2 = props.id) !== null && _props$id2 !== void 0 ? _props$id2 : props.name,
      name: props.name,
      placeholder: props.placeholder,
      defaultValue: props.defaultValue,
      ref: ref,
      error: props.error ? true : false
    }), !!props.error && /*#__PURE__*/_jsx(Text, {
      color: "red.400",
      fontSize: "sm",
      "data-testid": "input-".concat(props.name, "-error"),
      children: props.error
    })]
  });
});
Input.displayName = 'Input';